module.exports = __webpack_public_path__ + "img/34af7970-f559-48a7-ae87-70c1a49198d2.9ba94298.png";